import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert, Button, ModalBody, ModalFooter } from 'reactstrap';

import ColumnVisibilityTable from './ColumnVisibilityTable';
import { ColumnVisibility, VisibilityOption } from './types';

interface PermissionsStepProps {
  error: string;
  columnVisibilities: ColumnVisibility[];
  visibilityOptions: VisibilityOption[];
  otherColumnLabels: Set<string>;
  onVisibilityChange: (key: string, visibility: string) => void;
  onLabelChange: (key: string, label: string) => void;
  onBack: () => void;
  onSubmit: () => void;
}

const PermissionsStep: FC<PermissionsStepProps> = ({
  error,
  columnVisibilities,
  visibilityOptions,
  otherColumnLabels,
  onVisibilityChange,
  onLabelChange,
  onBack,
  onSubmit,
}) => (
  <>
    <ModalBody>
      {error && <Alert color="danger">{error}</Alert>}
      <p>
        <FormattedMessage
          id="app.custom_campaign_data.permissions.description"
          defaultMessage="Set the name and visibility for each column. Data will be visible to the selected roles."
        />
      </p>
      {columnVisibilities.length > 0 && (
        <ColumnVisibilityTable
          columns={columnVisibilities}
          visibilityOptions={visibilityOptions}
          otherColumnLabels={otherColumnLabels}
          onChange={onVisibilityChange}
          onLabelChange={onLabelChange}
        />
      )}
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onBack}>
        <FormattedMessage
          id="app.custom_campaign_data.back"
          defaultMessage="Back"
        />
      </Button>
      <Button
        color="primary"
        disabled={columnVisibilities.length === 0}
        onClick={onSubmit}
      >
        <FormattedMessage
          id="app.custom_campaign_data.upload"
          defaultMessage="Upload"
        />
      </Button>
    </ModalFooter>
  </>
);

export default PermissionsStep;
